import { useSelector } from "react-redux";
import {
  IconUserCircle,
  IconCurrencyDollar,
  IconCalendarEvent,
  IconBuildingEstate,
  IconHelp,
  IconLogout,
} from "@tabler/icons-react";
import useAuth from "../../hooks/useAuth";
import { AppStore } from "../../redux/store";
import { DropdownContainer, DropdownItem, DropdownDivider } from "./components/NavDropdownUsers/DropdownItem";

const NavBarLandlord = () => {
  const { country } = useSelector((store: AppStore) => store.country);
  const { handleLogout } = useAuth();

  return (
    <DropdownContainer>
      <DropdownItem icon={<IconUserCircle size={22} />} href={`/app/${country}/l/ld/mi-cuenta`}>
        Mi cuenta
      </DropdownItem>
      <DropdownItem icon={<IconCurrencyDollar size={22} />} href={`/app/${country}/l/ld/payments`}>
        Mis Inversiones
      </DropdownItem>
      <DropdownItem icon={<IconCalendarEvent size={22} />} href={`/app/${country}/l/ld/pre-booking`}>
        Mis pre-reservas
      </DropdownItem>
      <DropdownItem icon={<IconBuildingEstate size={22} />} href={`/app/${country}/l/properties`}>
        Ofertas y propiedades
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconHelp size={22} />} href={`/${country}/ayuda`}>
        Obtener ayuda
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconLogout size={22} />} onClick={handleLogout}>
        Cerrar sesión
      </DropdownItem>
    </DropdownContainer>
  );
};

export default NavBarLandlord;
